module.exports = __webpack_public_path__ + "img/horsetrack-team.87fc9f80.jpg";